











import Vue from 'vue'

export default Vue.extend({
  name: 'NotFoundPage',
  computed: {
    topPageUrl: function (): string {
      return `${location.host}${process.env.BASE_URL}#/`
    },
  },
})
